// removed by extract-text-webpack-plugin
module.exports = {"hex":"_2on4FoTeOkG2RN2XGji7k5","hex--active":"ZiX25TAZ9nKxx_YmFlgu-","hex--schlaemmbar":"_3qgrCy1ddF3ScvwOZvwFic","hex--belastbar":"gqMH27n3nbsam1XYMWA5g","hex--farbig":"_1JImPLoEYmUPmS9Bh5RfXJ","hex--sani":"_3SoMI8MmQKGYWyo19JY34r","hex--schnellfest":"_2zysvNFPTr1k2h7JLte_2V","hex--hoch-belastbar":"_7Hi5CqDC7gQtibHc-E0PI","hex--bitu":"_2qrixa_Rx2zlzCDNhOoYTN"};


//////////////////
// WEBPACK FOOTER
// ../components/Hexagon.module.scss
// module id = 459
// module chunks = 0